import { apiSlice } from '../api/apiSlice';

export const taskApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getTasks: builder.query({
            query: () => ({
                url: `/tasks`
            }),
            providesTags: ["Tasks"]
        }),
        getTask: builder.query({
            query: (id) => ({
                url: `/tasks/${id}`
            })
        }),
        addTask: builder.mutation({
            query: (data) => ({
                url: "/tasks",
                method: "POST",
                body: data,
            }),
            async onQueryStarted(arg, { queryFulfilled, dispatch }) {
                // update task cache pessimistically
                try {
                    const res = await queryFulfilled;

                    dispatch(
                        apiSlice.util.updateQueryData(
                            "getTasks",
                            undefined,
                            (draft) => {
                                draft.push(res.data)
                            }));
                } catch (err) {

                }
            },
        }),
        editTaskStatus: builder.mutation({
            query: ({ id, data }) => ({
                url: `/tasks/${id}`,
                method: "PATCH",
                body: data,
            }),
            async onQueryStarted(arg, { queryFulfilled, dispatch }) {
                // optimistic cache update 
                dispatch(
                    apiSlice.util.updateQueryData(
                        "getTasks",
                        undefined,
                        (draft) => {
                            const draftTask = draft?.find(item => Number(item.id) === arg.id);
                            draftTask.status = arg.data.status
                        }
                    )
                );

                try {
                    await queryFulfilled;
                } catch (err) {
                    dispatch(apiSlice.util.invalidateTags(['Tasks']))
                }
            },
        }),

        editTask: builder.mutation({
            query: ({ id, data }) => ({
                url: `/tasks/${id}`,
                method: "PATCH",
                body: data,
            }),
            async onQueryStarted(arg, { queryFulfilled, dispatch }) {
                // update task cache pessimistically
                try {

                    const res = await queryFulfilled;
                    // update tasks state
                    dispatch(
                        apiSlice.util.updateQueryData(
                            "getTasks",
                            undefined,
                            (draft) => {
                                return draft.map(item => {
                                    if (Number(item.id) === arg.id) {
                                        return { ...res.data }
                                    } else {
                                        return item
                                    }
                                })
                            }));
                    // update single task state
                    dispatch(
                        apiSlice.util.updateQueryData(
                            "getTask",
                            arg.id.toString(),
                            (draft) => {
                                return { ...res.data }
                            }));

                } catch (err) {

                }
            },
        }),

        deleteTask: builder.mutation({
            query: (id) => ({
                url: `/tasks/${id}`,
                method: "DELETE"
            }),
            async onQueryStarted(arg, { queryFulfilled, dispatch }) {
                // optimistic cache update 
                dispatch(
                    apiSlice.util.updateQueryData(
                        "getTasks",
                        undefined,
                        (draft) => {
                            return draft.filter(item => item.id !== arg)
                        }
                    )
                );

                try {
                    await queryFulfilled;
                } catch (err) {
                    dispatch(apiSlice.util.invalidateTags(['Tasks']))
                }
            },
        }),
    }),
});

export const { useAddTaskMutation, useGetTasksQuery, useGetTaskQuery, useEditTaskStatusMutation, useEditTaskMutation, useDeleteTaskMutation } = taskApi;